import { useState } from 'react';
import useSWRInfinite from 'swr/infinite';
import { jsonFetcherWithHandler as fetcher } from 'lib/swr';
import { gridItemHandler } from '../gridV2/CommunityView';

import { CommunityGridItem, CommunityUserProfile } from 'types/community';
import CommunityGrid from '../gridV2/CommunityGrid';
import { getCommunityProfilePostsUrl } from 'lib/community';
import EmptyPlaceholder from '../profile/EmptyPlaceholder';

type Props = {
  profile: CommunityUserProfile;
};

export default function UserPostsGrid({ profile }: Props) {
  const [hasMoreItems, setHasMoreItems] = useState<boolean>(true);

  function getPostsUrl(
    pageIndex: Number,
    previousPageData: CommunityGridItem[] | null
  ) {
    const id = profile?.ownerId;
    if (id === undefined) {
      return null;
    }
    if (pageIndex === 0) {
      return getCommunityProfilePostsUrl(id.toString());
    }

    if (previousPageData === null || previousPageData.length === 0) {
      setHasMoreItems(false);
      return null;
    }

    const before =
      previousPageData[previousPageData.length - 1].communityRevisionId;
    return getCommunityProfilePostsUrl(id.toString(), before);
  }

  const {
    data: gridItems,
    setSize,
    isValidating,
  } = useSWRInfinite<CommunityGridItem>(getPostsUrl, fetcher(gridItemHandler));

  function onScrollNearEnd() {
    setSize((size) => size + 1);
  }

  const flattenedGridItems = gridItems ? gridItems.flat() : null;
  return (
    <div>
      {flattenedGridItems && flattenedGridItems.length === 0 ? (
        <EmptyPlaceholder
          text={`It looks like ${profile.username} hasn't made any posts yet.`}
        />
      ) : (
        <CommunityGrid
          gridItems={flattenedGridItems}
          hasMoreItems={hasMoreItems}
          isValidating={isValidating}
          onScrollNearEnd={onScrollNearEnd}
        />
      )}
    </div>
  );
}
